module.exports = __webpack_public_path__ + "frontend/images/gold/bg/pattern.png?c4730b3225a410b7e9edbf6c243a56b3";